import { useQuery } from '@tanstack/react-query';
import { getAirData } from './Options';
import BrightenChart from './components/BrightenChart';
import classes from './App.module.css';
import Card from './components/Card';
import CGPieChart from './components/CGPieChart';

function App() {
	const queryArgs = { action: 'SAS_handleAJAX', function: 'getDashboardData', which: 'brighten' }
	const recipientArgs = { action: 'SAS_handleAJAX', function: 'recipientData' }
	const volunteerArgs = { action: 'SAS_handleAJAX', function: 'volunteerData' }
	const letters = useQuery({queryKey: ['brighten'], queryFn: () => getAirData(queryArgs) });
	const recipient = useQuery({queryKey: ['recipient'], queryFn: () => getAirData(recipientArgs) });
	const volunteers = useQuery({ queryKey: ['volunteers'], queryFn: () => getAirData(volunteerArgs) });


	if (letters.isLoading) { return <p>Loading...</p>; }
	
	return (
		<div className={classes.App}>
			<BrightenChart data={letters} type={"allCards"} title="Lives Brightened over Time" />
			{volunteers.isFetched &&
			<div className={classes.Numbers}>
				<Card title={"Lives Brightened"} 		text={letters.data.grandTotal} type={"main"} /> 
				<Card title={"Individual Volunteers"} 	text={volunteers.data.indTotal} type={"main"} /> 
				<Card title={"Group Volunteers"} 		text={volunteers.data.grpTotal} type={"main"} /> 
				<Card title={"Volunteer States"} 		text={volunteers.data.stateTotal} type={"main"} /> 
			</div>
			}
			{recipient.isFetched &&
			<div className={classes.Numbers}>
				<Card title={"Letters Needed"} 			text={recipient.data.needed} type={"main"} /> 
				<Card title={"Individual Recipients"} 	text={recipient.data.indTotal} type={"main"} /> 
				<Card title={"Group Recipients"} 		text={recipient.data.grpTotal} type={"main"} /> 
				<Card title={"Recipient States"} 		text={recipient.data.stateTotal} type={"main"} /> 
			</div>
			}
			<BrightenChart data={letters} type={"indCards"} title="Individuals Brightened by Month"/>
			<BrightenChart data={letters} type={"grpCards"} title="Groups Brightened by Month" />
			<h3 className={classes.pieChartTitle}>Cards by Category</h3>
			<CGPieChart    data={recipient.data.cardGroupData}  type={"pieChart"} title="" />
		</div>
	);
}
//
export default App;